// Copyright (c) 2017 Deere & Company

import * as actionCreators from './action-creators';
import ReimbursementSummaryClaims from './components';

import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    ...state.reimbursementSummary.claims,
    columnApi: state.columnApi,
    gridApi: state.gridApi,
    isDefaultColumnStateAvailable: state.reportVariant.layouts.length ? Boolean(state.reportVariant.layouts.find(layout => layout.name === '').columnState.length) : false,
    isInitialLoad: state.reportVariant.isInitialLoad,
    isReportColumnsVisible: state.reportVariant.isReportColumnsVisible,
    layouts: state.reportVariant.layouts,
    selectedLayout: state.reportVariant.selectedLayout
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;
    const queryParams = parentProps.location.query;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        queryParams,
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(ReimbursementSummaryClaims);



// WEBPACK FOOTER //
// ./src/reimbursement-summary/claims/state-connector.js